import React, { useEffect, useState } from 'react';
import { History } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { useAuth } from '../../context/AuthContext';
import { useWallet } from '../../context/WalletContext';
import { usdtService } from '../../services/usdtService';
import { formatMoney } from '../../utils/formatMoney';

function TransactionList({ title, items, type }) {
  if (!items.length) {
    return <p className="text-sm text-gray-500">ยังไม่มีรายการ{title}</p>;
  }

  return (
    <ul className="space-y-2">
      {items.map((item) => (
        <li
          key={`${type}-${item.id}`}
          className="flex items-center justify-between rounded-lg bg-gray-50 px-4 py-3 text-sm"
        >
          <div>
            <p className="font-semibold text-brand-red">
              {type === 'deposit' ? '+' : '-'}
              {formatMoney(item.amount)}
            </p>
            <p className="text-xs text-gray-500">
              {new Date(item.created_at).toLocaleString('th-TH')}
            </p>
            {item.tx_hash ? (
              <p className="mt-1 truncate font-mono text-[11px] text-gray-400">
                {item.tx_hash}
              </p>
            ) : null}
          </div>
          <span
            className={`rounded-full px-2 py-1 text-xs font-medium ${
              item.status === 'สำเร็จ'
                ? 'bg-green-100 text-green-700'
                : item.status === 'ล้มเหลว'
                  ? 'bg-red-100 text-brand-red'
                  : 'bg-amber-100 text-amber-700'
            }`}
          >
            {item.status}
          </span>
        </li>
      ))}
    </ul>
  );
}

export function UsdtTransactionHistory() {
  const { isAuthenticated } = useAuth();
  const { balance } = useWallet();
  const [deposits, setDeposits] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);

  useEffect(() => {
    if (!isAuthenticated) {
      setDeposits([]);
      setWithdrawals([]);
      return;
    }

    Promise.all([usdtService.getDeposits(), usdtService.getWithdrawals()]).then(
      ([depositItems, withdrawalItems]) => {
        setDeposits(depositItems);
        setWithdrawals(withdrawalItems);
      }
    );
  }, [isAuthenticated, balance]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <History className="h-5 w-5" />
          ประวัติฝาก-ถอน
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-6 lg:grid-cols-2">
        <div>
          <h4 className="mb-3 text-sm font-semibold text-gray-800">ฝาก</h4>
          <TransactionList title="ฝาก" items={deposits} type="deposit" />
        </div>
        <div>
          <h4 className="mb-3 text-sm font-semibold text-gray-800">ถอน</h4>
          <TransactionList title="ถอน" items={withdrawals} type="withdraw" />
        </div>
      </CardContent>
    </Card>
  );
}
